import { graphql } from "@opensea/graphql"
import { useSwapCurrenciesFragment } from "../../../hooks/useSwapCurrencies"

export const SwapDetailsProviderFeeItemFragment = graphql(
  `
    fragment SwapDetailsProviderFeeItem on SwapRouteResult {
      ...useSwapCurrencies
      ... on SwapRoute {
        pricePerFromAsset {
          usd
          token {
            chain {
              arch
            }
          }
        }
        costs {
          costType
          cost {
            usd
          }
        }
      }
    }
  `,
  [useSwapCurrenciesFragment],
)
